import axios from 'axios';
const CONTROLLER_PATH = 'user'
class AuthService {
    login(user) {
        return axios
            .post(CONTROLLER_PATH + '/authenticate', {
                username: user.username,
                password: user.password,
            })
            .then((response) => response.data);
    }
    GetAccess() {
        return axios.get(CONTROLLER_PATH + '/GetAccess').then((response) => ({
            data: response.data,
        }));
    }
    GetRoles() {
        return axios.get(CONTROLLER_PATH + '/GetRoles').then((response) => ({
            data: response.data,
        }));
    }
    GetUserRoles() {
        return axios.get(CONTROLLER_PATH + '/GetUserRoles').then((response) => ({
            data: response.data,
        }));
    }
    logout() {}

    register(user) {
        return user;
    }
}

export default new AuthService();